import React from 'react';
import Image from 'next/image';
import { makeStyles } from '@material-ui/core';

import { Feedback } from 'domain/types';

interface Props {
  feedback: Feedback;
}

const FeedbackItem: React.FC<Props> = ({
  feedback: {
    image: { height, width, url }
  }
}) => {
  const classes = useStyles();

  return (
    <article className={classes.item}>
      <Image src={url} width={width} height={height} quality={75} />
    </article>
  );
};

const useStyles = makeStyles((theme) => ({
  item: {
    display: 'inline-block',
    width: '100%',
    position: 'relative',
    transition: '200ms ease-in',
    paddingTop: theme.spacing(2),
    '&:hover': {
      zIndex: 1,
      transform: 'scale(1.3)'
    },
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(4),
      '&:hover': {
        zIndex: 1,
        transform: 'scale(1.2)'
      }
    }
  }
}));

export default FeedbackItem;
